// Production target; override via VITE_AUTH_ORIGIN for dev against the
// preview Worker (prism-auth.pretema9.workers.dev) or localhost wrangler dev.
export const AUTH_ORIGIN =
  (import.meta.env.VITE_AUTH_ORIGIN as string | undefined) ??
  "https://auth.prismstreaming.com";

// Fixed public entry hostname used for "Open away" links. user_servers has
// no distinct public-host/public-port column today — every install's away
// link rides the same gateway-forwarded port as its LAN link (see
// decision-web-access-three-networks-2026-08-23 in PreteServer-dev and
// lib/serverLinks.ts). If installs ever get distinct public mappings, this
// becomes a per-row field instead of a constant.
export const PUBLIC_ENTRY_HOST =
  (import.meta.env.VITE_PUBLIC_ENTRY_HOST as string | undefined) ??
  "play.prismstreaming.com";
